import React from 'react';
import FMActionItem from '../../common/fm-action-item/fm-action-item';
import { ActionItemProps } from '../../../models/experiencefragments/action-item';

const FMActionItemRecall = (props: ActionItemProps) => {
    const { content, requiredLabel, recommendedLabel } = props;

    return (
        <FMActionItem
            required={true}
            content={content}
            requiredLabel={requiredLabel}
            recommendedLabel={recommendedLabel}
        />
    );
};

export default FMActionItemRecall;
